// Date utilities — pure functions

export const parseExcelDate = (val) => {
    if (!val) return null;
    // Si es un número (fecha serial de Excel)
    if (typeof val === 'number') {
        const date = new Date((val - 25569) * 86400 * 1000);
        if (isNaN(date.getTime())) return null;
        return date.toISOString().split('T')[0];
    }
    // Si ya es una fecha válida
    const d = new Date(val);
    if (!isNaN(d) && d.getFullYear() > 2000) {
        return d.toISOString().split('T')[0];
    }
    // Intentar parsear formato DD/MM/YYYY o MM/DD/YYYY
    const parts = String(val).split(/[\/\-]/);
    if (parts.length === 3) {
        // Asumir formato MM/DD/YYYY (común en Excel US)
        const month = parseInt(parts[0]);
        const day = parseInt(parts[1]);
        const year = parseInt(parts[2]);
        if (year > 2000 && month <= 12 && day <= 31) {
            return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        }
    }
    return null;
};

export const daysBetween = (d1, d2) => Math.round((new Date(d2) - new Date(d1)) / (1000 * 60 * 60 * 24));

// Parse a date string (YYYY-MM-DD) as local midnight, not UTC.
// new Date("2026-03-27") = UTC midnight → wrong local day in western timezones.
// This returns local midnight for the given date parts.
export const parseLocalDate = (val) => {
    if (!val) return null;
    if (val instanceof Date) { val = new Date(val); val.setHours(0, 0, 0, 0); return val; }
    const s = String(val);
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
    const d = new Date(val);
    if (!isNaN(d)) { d.setHours(0, 0, 0, 0); return d; }
    return null;
};

export const TODAY = new Date();
TODAY.setHours(0, 0, 0, 0);

// Register on window for inline module access
Object.assign(window, { parseExcelDate, daysBetween, parseLocalDate, TODAY });
